export default __webpack_public_path__ + "static/media/element_spec_43.a4d3f828.jpg";